import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Built using React & Three, by Laura Hiller</p>
    </footer>
  );
};

export default Footer;
